import React from 'react';
import { Animated, View } from 'react-native';

import { useLanguageStore } from '../../features/quiz-core/languageStore';
import { t } from '../../i18n/translations';
import PremiumButton from '../../shared/ui/PremiumButton';

interface AnimatedButtonProps {
  buttonScaleAnim: Animated.Value;
  handleGetStarted: () => void;
  showConfetti: boolean;
}

const AnimatedButton: React.FC<AnimatedButtonProps> = ({ buttonScaleAnim, handleGetStarted, showConfetti }) => {
  const { language } = useLanguageStore();

  return (
    <Animated.View style={{ transform: [{ scale: buttonScaleAnim }] }}>
      <PremiumButton
        text={t('landing.startPlaying', language)}
        onPress={handleGetStarted}
        gradientColors={['#FFE98A', '#F6BE3A']}
        iconName="arrow-forward"
        style={{ width: '100%', borderRadius: 50 }}
        textStyle={{ color: '#160B2E', fontSize: 18, fontWeight: '900' }}
        accessibilityLabel={t('landing.startPlaying', language)}
      />
      {showConfetti && (
        <View style={{ position: 'absolute', left: '50%', bottom: 0, transform: [{ translateX: -24 }] }}>
          {/* Sparkle/confetti animation here (can be Lottie or custom) */}
        </View>
      )}
    </Animated.View>
  );
};

export default AnimatedButton;
